<template>
  <div class="appdetail">
    <!-- 标题、按钮 -->
    <div class="appdetail-title">
      <div class="appdetail-title-top clearfix">
        <div class="app-buttons">
          <el-button
            icon="icon-save"
            class="btn-"
            type="primary"
            size="mini"
            @click="saveBtn('Update')"
          >
            <font>保存</font>
          </el-button>
          <el-button
            type="success"
            class="btn-"
            size="mini"
            @click="saveBtn('Submit')"
            v-show="addtitle"
            >保存并继续</el-button
          >
        </div>
      </div>
    </div>
    <el-tabs
      class="appdetail-content"
      type="border-card"
      v-model="currentDetailTabsModel"
      @tab-click="tabClick"
    >
      <el-tab-pane label="列表" name="列表"> </el-tab-pane>
      <el-tab-pane label="详情" name="详情">
        <div
          class="appdetail-content"
          :style="{ height: 'calc(100vh - 205px)' }"
        >
          <el-form
            inline-message
            :model="user"
            :rules="rules"
            ref="user"
            :label-position="labelPositions"
            class="demo-user"
          >
            <div class="content-accordion">
              <el-collapse v-model="activeNames">
                <el-collapse-item title="用户基本资料" name="1">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item
                        label="用户名"
                        prop="username"
                        label-width="100px"
                      >
                        <el-input
                          v-model="user.username"
                          :disabled="!addtitle"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="addtitle">
                      <el-form-item
                        label="密码"
                        prop="password"
                        label-width="100px"
                      >
                        <el-input
                          auto-complete="new-password"
                          type="password"
                          v-model="user.password"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="姓名"
                        prop="nickname"
                        label-width="100px"
                      >
                        <el-input v-model="user.nickname"></el-input>
                        <span class="error"></span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="职务"
                        prop="post"
                        label-width="100px"
                      >
                        <el-input v-model="user.post"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="工号"
                        prop="worknumber"
                        label-width="100px"
                      >
                        <el-input v-model="user.worknumber"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="性別" prop="sex" label-width="100px">
                        <el-radio v-model="user.sex" label="1">男</el-radio>
                        <el-radio v-model="user.sex" label="0">女</el-radio>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="身份证号"
                        prop="idnumber"
                        label-width="100px"
                      >
                        <el-input v-model="user.idnumber"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="手机号"
                        prop="phone"
                        label-width="100px"
                      >
                        <el-input v-model="user.phone"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="联系电话"
                        prop="telephone"
                        label-width="100px"
                      >
                        <el-input v-model="user.telephone"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="电子邮箱"
                        prop="email"
                        label-width="100px"
                      >
                        <el-input v-model="user.email"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="用户有效期"
                        prop="user_active_date"
                        label-width="100px"
                      >
                        <el-date-picker
                          style="width: 100%"
                          :disabled="disabled"
                          v-model="user.user_active_date"
                          type="date"
                          :placeholder="disabled ? '' : '选择日期'"
                          value-format="yyyy-MM-dd HH:mm:ss"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>

                    <el-col :span="8">
                      <el-form-item
                        label="学历"
                        prop="education"
                        label-width="100px"
                      >
                        <el-select
                          v-model="user.education"
                          placeholder="请选择"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="(item, index) in educationData"
                            :key="index"
                            :value="item.id"
                            :label="item.name"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="是否离职"
                        prop="leaveoffice"
                        label-width="100px"
                      >
                        <el-radio-group v-model="user.leaveoffice">
                          <el-radio :label="1">是</el-radio>
                          <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="所属机构"
                        prop="deptName"
                        label-width="100px"
                      >
                        <el-input v-model="user.deptName" :disabled="edit">
                          <el-button
                            slot="append"
                            icon="el-icon-search"
                            @click="getDept"
                          ></el-button>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="角色"
                        prop="rolecode"
                        label-width="100px"
                      >
                        <el-select
                          v-model="user.rolecode"
                          multiple
                          filterable
                          default-first-option
                          value-key="item.id"
                          style="width: 100%"
                          @change="showUserRole"
                        >
                          <el-option
                            v-for="(item, index) in selectData"
                            :key="index"
                            :value="item.code"
                            :label="item.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="工作流任务代理人"
                        prop="taskdeputydesc"
                        label-width="100px"
                      >
                        <el-input
                          v-model="user.taskdeputydesc"
                          disabled
                          placeholder="请选择"
                        >
                          <i
                            slot="suffix"
                            class="el-icon-circle-close input-suffix-icon"
                            @click="
                              clearInput(user, ['taskdeputydesc', 'taskdeputy'])
                            "
                          ></i>
                          <el-button
                            slot="append"
                            icon="el-icon-search"
                            @click="choose(user, taskdeputChooseParam)"
                          ></el-button>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="代理时间"
                        prop="deputytime"
                        label-width="100px"
                      >
                        <el-date-picker
                          style="width: 100%"
                          v-model="user.deputytime"
                          type="datetime"
                          placeholder="选择日期时间"
                          value-format="yyyy-MM-dd HH:mm:ss"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item
                        label="备注"
                        prop="tips"
                        label-width="100px"
                      >
                        <el-input
                          type="textarea"
                          rows="2"
                          :autosize="{ minRows: 2 }"
                          v-model="user.tips"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-collapse-item>

                <el-collapse-item title="其他" name="4" v-show="views">
                  <!-- 第一行 -->
                  <el-row :gutter="30">
                    <el-col :span="8">
                      <el-form-item
                        label="录入人"
                        prop="createby"
                        label-width="100px"
                      >
                        <el-input
                          v-model="user.createbyName"
                          :disabled="edit"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="录入时间"
                        prop="createTime"
                        label-width="100px"
                      >
                        <el-input v-model="user.createTime" :disabled="edit">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="机构"
                        prop="deptName"
                        label-width="100px"
                      >
                        <el-input
                          v-model="user.deptName"
                          placeholder="当前录入人机构"
                          :disabled="edit"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="修改人"
                        prop="updatebyName"
                        label-width="100px"
                      >
                        <el-input
                          v-model="user.updatebyName"
                          :disabled="edit"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="修改时间"
                        prop="updateTime"
                        label-width="100px"
                      >
                        <el-input v-model="user.updateTime" :disabled="edit">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :modal-append-to-body="false"
      title="机构"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
    >
      <!-- <div class="el-collapse-item pb10" aria-expanded="true" accordion > -->
      <div class="scrollbar" style="height: 380px">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText"
        ></el-input>
        <el-tree
          v-loading="deptloading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          ref="tree"
          :data="resourceData"
          show-checkbox
          node-key="id"
          default-expand-all
          :default-checked-keys="resourceCheckedKey"
          :props="resourceProps"
          @check="handleClicks"
          check-strictly
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
      <!-- </div> -->
      <div slot="footer">
        <el-button type="primary" @click="dailogconfirm">确 定</el-button>
        <el-button @click="resetTree">取 消</el-button>
      </div>
    </el-dialog>
    <vchoose
      ref="choose"
      :chooseParam="chooseParam"
      @updateChoose="updateChoose"
    ></vchoose>
  </div>
</template>

<script>

import { Loading } from 'element-ui'
import vchoose from "@/components/commonComponents/datachoose.vue";
export default {
  name: 'user_managementdetail',
  components: { vchoose },
  data() {
    var validatedeptname = (rule, value, callback) => {//所属机构
      if (this.user.deptName === undefined || this.user.deptName === '' || this.user.deptName === null) {
        callback(new Error('请选择所属机构'));
      } else {
        callback();
      }
    };
    return {
      currentDetailTabsModel: "详情",
      deptloading: false,
      changeflag: false,//监听值的变化
      wi: 1,
      basic_url: Config.dev_url,
      file_url: Config.file_url,
      user: {
        status: '1',
        rolecode: [],
        roles: [],
        sex: '0',
        ispermit: '0',
        islogin: '1',
        deptName: '',
        nickname: '',
        username: '',
        leaveoffice: 0
      },
      // customerList: [],
      searchList: {
        NAME: '',
        CODE: '',
        CONTACT_ADDRESS: '',
      },
      page: {
        currentPage: 1,
        pageSize: 20
      },
      value: '',
      editSearch: '',
      edit: true, //禁填
      show: false,
      isok1: true,
      isok2: false,
      activeName: 'first', //tabs
      activeNames: ['1', '2', '3', '4'], //手风琴数量
      labelPosition: 'top', //表格
      labelPositions: 'right',
      dialogVisible: false, //对话框
      addtitle: true, //添加弹出框titile
      disabled: true,
      i: 0,
      rules: {
        deptName: [{ required: true, validator: validatedeptname }], //所属机构
        //        education: [{ required: true, message: '必填', trigger: 'blur' }],
        rolecode: [{ required: true, trigger: 'change', message: '必填', }],
        username: [
          { required: true, message: '必填', trigger: 'change', },
          //          { validator: this.Validators.isUserName, trigger: 'change' },//引用 isUserName
          //          { type: 'string', min: 4, max: 20, message: '用户名不小于4位，不大于20位', trigger: 'change' },
        ],
        password: [
          { required: true, trigger: 'change', message: '必填' },
          //          { validator: this.Validators.isValidatePass, trigger: 'change' },
        ],
        sex: [{ required: true, trigger: 'change', message: '必填' }],
        ispermit_authorization: [{ required: true, trigger: 'change', message: '必填' }], //授权
        //        islogin: [{ required: true, trigger: 'change', message: '必填' }], //登陆
        mac_address: [{ required: true, trigger: 'change', message: '必填', }],
        ip_address: [{ required: true, trigger: 'change', message: '必填', }],
        nickname: [
          { required: true, trigger: 'change', message: '必填' },
          //          { trigger: 'change', validator: this.Validators.isNickname }
        ],
        worknumber: [
          { required: true, trigger: 'change', message: '必填' },
          // { validator: this.Validators.isWorknumber, trigger: 'change' },//引用 isWorknumber
        ],
        t_date: [{ required: true, trigger: 'change', message: '必填', }],
        t_description: [{ required: true, trigger: 'change', message: '必填', }],
        status: [{ required: true, trigger: 'change', message: '必填', }],
        step: [{ required: true, trigger: 'change', message: '必填', }],
        c_date: [{ required: true, trigger: 'change', message: '必填', }],
        c_num: [{ required: true, trigger: 'change', message: '必填', }],
        c_name: [{ required: true, trigger: 'change', message: '必填', }],
        ipaddress: [{ required: false, trigger: 'change', validator: this.Validators.isIpaddress }],
        macaddress: [{ required: false, trigger: 'change', validator: this.Validators.isMacaddress }],
        post: [{ required: false, trigger: 'change', validator: this.Validators.isSpecificKey }],
        tips: [{ required: false, trigger: 'change', validator: this.Validators.isSpecificKey }],
      },
      //tree树菜单
      resourceData: [], //数组，我这里是通过接口获取数据，
      resourceDialogisShow: false,
      resourceCheckedKey: [], //通过接口获取的需要默认展示的数组 [1,3,15,18,...]
      resourceProps: {
        children: "children",
        label: "fullname"
      },
      selectData: [], //角色
      educationData: [], //最高学历
      getCheckboxData: {},
      dept: false,
      views: false,//录入修改人信息
      noviews: true,//按钮
      hintshow: false,
      index: 0,
      filterText: '',
      chooseParam: {},
      taskdeputChooseParam: {
        title: "人员信息",
        isMulti: false,
        searchBtn: true,
        tableHeader: [
          {
            propName: "username",
            labelName: "用户名",
            targetAttribute: "taskdeputy",
            isSearch: 'yes',
            isShow: 'yes',
            width: '35%'
          },
          {
            propName: "nickname",
            labelName: "姓名",
            targetAttribute: "taskdeputydesc",
            isSearch: 'yes',
            isShow: 'yes',
            width: '35%'
          },
        ],
        search: [],
        url: "/api-user/users",
        method: "get"
      },
    };
  },
  methods: {
    clearInput(data, arr) {
      for (var i = 0; i < arr.length; i++) {
        data[arr[i]] = ''
      }
    },
    choose(target, chooseParam) {
      for (var i = 0; i < chooseParam.tableHeader.length; i++) {
        chooseParam.tableHeader[i].targetObject = target;
      }
      this.chooseParam = chooseParam;
      this.$refs.choose.getListData("new", this.chooseParam);
    },
    updateChoose(data) {
      this.$forceUpdate();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.fullname.indexOf(value) !== -1;
    },

    showUserRole() {
    },
    resetTree() {
      this.dialogVisible = false;
      this.resourceCheckedKey = [];
      // this.customerList = [];
      this.page.currentPage = 1;//页码重新传值
      this.page.pageSize = 20;//页码重新传值
    },
    editpassword() {//点击修改密码按钮跳转到修改密码页面
      this.$router.push({ path: '/passwordedit' })
    },
    currentSel(selVal) {
      this.selVal = selVal;
    },
    //表头居中
    rowClass({ row, rowIndex }) {
      return 'text-align:center'
    },
    SelChange(val) {
      this.selUser = val;
      var _this = this;
    },
    handleClick(tab, event) {
    },

    //清空
    reset() {
      this.user = {
        companyName: '',
        deptName: '',
        username: '',
        password: '',
        nickname: '',
        birthday: '',
        sexName: '',
        idnumber: '',
        entrytime: '',
        rolecode: [],
        roles: [],
        worknumber: '',
        phone: '',
        email: '',
        address: '',
        tips: '',
        enabled: true,
      }
      this.setDefaultRole();
    },
    //获取当前默认角色
    setDefaultRole() {
      this.$axios.get(Config.dev_url + '/api-user/roles/getdefaid', {}).then((res) => {
        var defaultid = res.data;
        this.user.rolecode.push(defaultid);
      }).catch((err) => {
      })
    },
    //
    handleClicks(data, checked, indeterminate) {
      this.getCheckboxData = data;
      if (checked) {
        this.$refs.tree.setCheckedNodes([data]);
        this.$refs.tree.setCheckedKeys([data.id]);
      } else {
        this.$refs.tree.setCheckedNodes([]);
      }
    },

    //添加显示弹窗
    addBtn() {
      this.user = {
        companyName: '',
        deptName: '',
        username: '',
        password: '',
        nickname: '',
        birthday: '',
        sexName: '',
        idnumber: '',
        entrytime: '',
        rolecode: [],
        roles: [],
        worknumber: '',
        phone: '',
        email: '',
        sex: '1',
        ispermit: '1',
        islogin: '1',
        // education: '本科',
        education: 41,
        address: '',
        tips: '',
        enabled: true,
        leaveoffice: 0
      };
      this.addtitle = true;
      this.currentDetailTabsModel = "详情"
    },
    setUpdateUserInfo() {
      this.user.changeby = this.currentuser["nickname"];
      this.docParam = {
        username: this.currentuser["username"],
        userid: this.currentuser["id"],
        deptid: this.currentuser["deptid"],
        deptfullname: this.currentuser["deptName"],
      };
      var date = new Date();
      this.user.createTime = this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    //这是查看
    view(item) {
      console.log(item)
      var url = Config.dev_url + '/api-user/users/' + item.worknumber;
      this.$axios.get(url, {}).then((res) => {
        this.user = res.data;
        if (res.data.sex != null) {
          this.user.sex = res.data.sex.toString();
        }
        console.log(!!res.data.education)
        console.log(res.data.education)
        console.log(typeof (res.data.education))
        if (!!res.data.education) {
          if (res.data.education == '本科') {
            this.user.education = 41;
          } else if (res.data.education == '硕士') {
            this.user.education = 42;
          } else {
            this.user.education = Number(res.data.education)
          }
        }

        this.user.enabled = this.user.enabled ? '活动' : '不活动';
        console.log(this.user)
        this.user.rolecode = this.user.rolecode ? this.user.rolecode.split(',') : [];
        var rolecode = this.user.rolecode;

        // for (var i = 0; i < rolecode.length; i++) {
        //   rolecode[i] = parseInt(rolecode[i]);
        // }
      }).catch((err) => {
      });
      this.getupdateuserdesc()
      this.getcreateuserdesc()
      this.addtitle = false;
      this.currentDetailTabsModel = "详情"
    },
    //保存users/saveOrUpdate
    saveBtn(parameter) {
      if (this.changeflag == true) {
        var _this = this;
        this.$refs.user.validate((valid) => {
          if (valid) {
            _this.user.enabled = true;
            var user = _this.user;
            var rolecode = [];
            user.rolecode = user.rolecode.join(',');
            if (!user.deputytime && typeof (user.deputytime) != "undefined" && user.deputytime != 0) {
              user.deputytime = "";
            }
            var url = Config.dev_url + '/api-user/users/saveOrUpdate';
            this.$axios.post(url, user).then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success',
                });
                if (parameter == 'Submit') {
                  this.user = {
                    companyName: '',
                    deptName: '',
                    username: '',
                    password: '',
                    nickname: '',
                    birthday: '',
                    sexName: '',
                    idnumber: '',
                    entrytime: '',
                    rolecode: [],
                    roles: [],
                    worknumber: '',
                    phone: '',
                    email: '',
                    sex: '1',
                    ispermit: '1',
                    islogin: '1',
                    education: '41',
                    address: '',
                    tips: '',
                    enabled: true,
                    leaveoffice: 0
                  };
                }
                this.view(res.data.data);
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                });
                user.rolecode = user.rolecode.split(',');
                // console.log(user.rolecode);
                // var rolecode = this.user.rolecode;
                // for (var i = 0; i < rolecode.length; i++) {
                //   rolecode[i] = parseInt(rolecode[i]);
                // }
                // console.log(rolecode);
              }
            }).catch((err) => {
              user.rolecode = user.rolecode.split(',');
              // var rolecode = this.user.rolecode;
              // for (var i = 0; i < rolecode.length; i++) {
              //   rolecode[i] = parseInt(rolecode[i]);
              // }
            });
          } else {
            this.$message({
              message: '有必填项未填写，请重新填写',
              type: 'warning',
            });
          }
        })
      } else {
        this.$emit('request');
      }
    },

    //机构
    getDept() {
      this.dialogVisible = true;
      this.deptloading = true;
      var url = Config.dev_url + '/api-user/depts/treeMap'
      this.$axios.get(url, {}).then((res) => {
        this.deptloading = false;
        this.resourceData = res.data;
      }).catch((err) => {
      });
    },
    //角色
    getRole() {
      var url = Config.dev_url + '/api-user/roles';
      this.$axios.get(url, {}).then((res) => {
        console.log(res.data.data)
        this.selectData = res.data.data;
      }).catch(error => {
      })
    },
    //最高学历
    getEducation() {
      var url = Config.dev_url + '/api-user/dicts/findChildsByCode?code=EDUCATIONS';
      this.$axios.get(url, {}).then((res) => {
        this.educationData = res.data;
      }).catch(error => {
        console.log('请求失败');
      })
    },
    dailogconfirm() { //小弹出框确认按钮事件
      if (JSON.stringify(this.getCheckboxData) == "{}") {
        this.$message({
          message: '请选择数据',
          type: 'warning'
        });
      } else {
        this.user.deptName = this.getCheckboxData.fullname;//名称
        this.user.deptcode = this.getCheckboxData.code;
        this.resetTree();
      }
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.resetTree();
        })
        .catch(_ => {
          console.log('取消关闭');
          $('.v-modal').hide();
        });
    },
    //tab选项卡点击
    tabClick(tab) {
      if (tab.label == "列表") {
        this.$store.commit('setcurrentShowPage', 1)
        this.$emit("requestData")
      } else {
        this.$store.commit('setcurrentShowPage', 2)
      }
    },
    //关闭抽屉按钮点击
    closeBtn() {
      this.$emit("requestData")
    },
    //获取创建人描述
    getcreateuserdesc() {
      if (!!this.user.createuser) {
        var url = Config.dev_url + '/api-user/users/' + this.user.worknumber
        this.$axios.get(url).then((res) => {
          this.$set(this.user, 'createuserdesc', res.data.nickname)
        }).catch((err) => {
        });
      }
    },
    //获取修改人描述
    getupdateuserdesc() {
      if (!!this.user.updateuser) {
        var url = Config.dev_url + '/api-user/users/' + this.user.worknumber
        this.$axios.get(url).then((res) => {
          this.$set(this.user, 'updateuserdesc', res.data.nickname)
        }).catch((err) => {
        });
      }
    },

  },
  mounted() {
    this.getRole();
    this.getEducation();
  },
  computed: {
    //当前左侧菜单选中的信息
    currentSelectMenuData() {
      return this.$store.state.currentSelectMenuData
    },
    //左侧菜单以及应用详情抽屉显示状态
    menuAndDrawer() {
      return this.$store.state.menuAndDrawer
    },
    //当前登录人信息
    currentuser() {
      return this.$store.state.currentuser
    },
  },
  watch: {
    user: {
      handler: function (obj) {
        if (this.wi != 1) {
          this.changeflag = true;
        }
        this.wi++;
      },
      deep: true
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    //左侧菜单点击关闭抽屉
    menuAndDrawer(val) {
      this.drawer = val
    },
  }
}
</script>

<style scoped>
</style>
